// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';

//COMPONENT

class ProductTypeItem extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
        };

        this.toggleDropDown = this.toggleDropDown.bind(this);
        this.deleteType = this.deleteType.bind(this);
    }

    toggleDropDown() {
        this.setState({ dropdownOpen: !this.state.dropdownOpen});
    }

    deleteType(){
        this.toggleDropDown();   
        this.props.deleteItem(this.props.typeId);
    }

    render() {
        return (
            <div className={'product-type-item'}>

                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                    <div className='product-type-more'> 
                        <DropdownToggle className="hidden-dropdown" >
                        </DropdownToggle>
                        <img className='equipment-more-image noselect' src={require('../../../../images/dotdotdot.png')} />
                    </div>

                    <DropdownMenu>
                        <DropdownItem onClick={this.deleteType}>{this.props.deleteTerm}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                
                <div className='type-details'>
                    <div >
                        <div className='type-title'> {this.props.typeName} </div>
                    </div>
                </div>
                
            </div>
        );
    }
}

ProductTypeItem.propTypes = {
    history: PropTypes.object.isRequired,
    typeName: PropTypes.string.isRequired,
    typeId: PropTypes.string.isRequired,
    deleteItem: PropTypes.func.isRequired,
    deleteTerm: PropTypes.string.isRequired
};

const hoc = withRouter(ProductTypeItem);

// EXPORT COMPONENT
export { hoc as ProductTypeItem };


// WEBPACK FOOTER //
// ./src/components/pages/Equipment/Details/ProductTypeItem.js